import { MatDateFormats } from '@angular/material/core';

/**
 * Explicit DD/MM/YYYY date formats for Angular Material datepickers.
 *
 * Does not depend on the en-GB moment locale bundle being loaded (it isn't),
 * so datepickers render UK-style dates regardless. Shared by the global
 * provider in `app.config.ts` and any component that needs a local override.
 */
export const UK_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
